import Vector from "../../model/math/Vector";
import SkillNode from "../../model/skillTree/SkillNode";
import { Settings } from "../../Settings";
import Page from "../framework/Page";
import View from "../framework/View";

export default class NodeConnectionView extends View {
    /**
     * @param {string} parentId 
     * @param {SkillNode} parentNode
     * @param {SkillNode} childNode
     */
    constructor(parentId, parentNode, childNode) {
        super(parentId, parentId + '_' + parentNode.id + '_' + childNode.id + '_con');

        /**
         * @constant
         * @type {SkillNode}
         */
        this.parentNode = parentNode;
        /**
         * @constant
         * @type {SkillNode}
         */
        this.childNode = childNode;

        /**
         * @constant
         * @type {SkillNode}
         */
        this.originNode = this.getTopLeftNode();

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @constant
         * @type {Vector}
         */
        this.displayCoordinate = new Vector(0, 0);
    }

    /**
     * @override
     */
    initializeView() {
        super.initializeView();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('NodeConnectionView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        const vertical = this.isConnectionVertical();

        const className = this.isConnectionVertical() ? 'connection-vertical' : 'connection-horizontal';

        this.mainElement = Page.createElement('div', parent, this.elementId, className);
        //const connectionAfterElement = Page.createElement('div', this.connectionElement, id + '_connectorAfter', 'connection-after');

        // Handle cases where the parent/node connection spans more than one grid cell.
        if (vertical) {
            this.mainElement.style.height = Math.abs(this.parentNode.graphCoordinate.y - this.childNode.graphCoordinate.y) + 'px';
        }
        else {
            this.mainElement.style.width = Math.abs(this.parentNode.graphCoordinate.x - this.childNode.graphCoordinate.x) + 'px';
        }

        this.setInitialVisibility(true);

        this.updatePosition();
    }

    /**
     * @override
     */
    updateViewContents() {
        this.updatePosition();
    }

    /**
     * @private
     */
    updatePosition() {

        if (this.displayCoordinate.equals(this.originNode.viewCoordinate)) {
            return;
        }
        this.displayCoordinate.copy(this.originNode.viewCoordinate);

        const offsetX = Settings.skillGraph.connectorOffsetX;
        const offsetY = Settings.skillGraph.connectorOffsetY;

        this.mainElement.style.left = (this.originNode.viewCoordinate.x + offsetX) + 'px';
        this.mainElement.style.top = (this.originNode.viewCoordinate.y + offsetY) + 'px';
    }

    /**
     * @private
     * @returns {boolean}
     */
    isConnectionVertical() {
        const other = this.originNode === this.childNode ? this.parentNode : this.childNode;

        const originCoord = this.originNode.graphCoordinate;
        const otherCoord = other.graphCoordinate;

        // The nodes are connected vertically if their x-coord is the same.
        return originCoord.x === otherCoord.x;
    }

    /**
     * Figure out which node we should use as the 'origin' of the connection.
     * @private
     * @returns {SkillNode}
     */
    getTopLeftNode() {
        const parentCoord = this.parentNode.graphCoordinate; // Use the graph coordinate, the view coordinate isn't initialized yet.
        const childCoord = this.childNode.graphCoordinate;

        // Parent/Child are above/below each other.
        if (parentCoord.x === childCoord.x) {
            if (parentCoord.y < childCoord.y) {
                return this.parentNode;
            }
            else {
                return this.childNode;
            }
        }

        // Parent/Child are left/right of each other
        if (parentCoord.y === childCoord.y) {
            if (parentCoord.x < childCoord.x) {
                return this.parentNode;
            }
            else {
                return this.childNode;
            }
        }

        // We really shouldn't end up with diagonal parent/child connections.
        if (parentCoord.x < childCoord.x) {
            return this.parentNode;
        }

        return this.childNode;
    }
}